/**
 * Agent timeline API client (spec #43 §3/§5).
 *
 * Two calls, deliberately asymmetric: `getTimelineHead` is the CHEAP poll
 * (one indexed query server-side) and `getAgentTimeline` is the real page.
 * The hook polls the former and fetches the latter only when the watermark
 * moves, so a poll never costs a page render.
 */

import { createHeaders } from './apiClient';
import { handleResponse } from './httpResponse';
import type { TimelineHead, TimelinePage, TimelineQuery } from '../types/timeline';

const API_BASE_URL = import.meta.env.VITE_API_URL || '';

export async function getAgentTimeline(
  domain: string,
  query: TimelineQuery = {},
): Promise<TimelinePage> {
  const params = new URLSearchParams();
  if (query.limit !== undefined) params.set('limit', String(query.limit));
  if (query.before) params.set('before', query.before);
  if (query.since) params.set('since', query.since);
  if (query.kinds?.length) params.set('kinds', query.kinds.join(','));

  const qs = params.toString();
  const response = await fetch(
    `${API_BASE_URL}/api/agents/${encodeURIComponent(domain)}/timeline${
      qs ? `?${qs}` : ''
    }`,
    { method: 'GET', headers: createHeaders() },
  );
  return handleResponse<TimelinePage>(response);
}

export async function getTimelineHead(since?: string): Promise<TimelineHead> {
  const qs = since ? `?since=${encodeURIComponent(since)}` : '';
  const response = await fetch(`${API_BASE_URL}/api/agents/timeline/head${qs}`, {
    method: 'GET',
    headers: createHeaders(),
  });
  return handleResponse<TimelineHead>(response);
}
